<!--
 * @Author: yejinliang
 * @Date: 2021-12-13 18:14:49
 * @LastEditTime: 2022-04-21 14:22:03
 * @LastEditors: yejinliang
 * @Description: 二级导航
-->
<template>
  <div class="nav-second">
    <router-link
      tag="div"
      v-for="nav in router"
      :key="nav.name"
      :to="nav.path"
      class="nav-second-item"
      exact-active-class="nav-second-item_ac"
    >
      <img :src="getImage(nav)" alt />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NavSecond',
  props: {
    router: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getImage(currentRoute) {
      const { name: matchedRouteName } = this.$route.matched[1]
      const { name: currentRouteName, meta } = currentRoute
      const currentImgObj = meta?.imgUrl
      if (!currentImgObj) return ''
      return require(`../../assets/${
        currentRouteName === matchedRouteName
          ? currentImgObj.act
          : currentImgObj.def
      }.png`)
    },
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.nav-second {
  position: absolute;
  bottom: 40px;
  left: 0px;
  right: 0px;
  width: 1440px;
  height: 100px;
  pointer-events: all;
  margin: auto;
  display: flex;
  justify-content: center;
  z-index: 10;
  align-items: flex-end;
  &-item {
    margin: 0 20px;
    width: 450px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
     
    }
 
  }
  &-item_ac {
    margin: 0 20px;
    width: 450px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      
    }
    
  }
}
</style>
